import { render, staticRenderFns } from "./ProfileFields.vue?vue&type=template&id=9287b008&scoped=true&"
import script from "./ProfileFields.vue?vue&type=script&lang=js&"
export * from "./ProfileFields.vue?vue&type=script&lang=js&"
import style0 from "./ProfileFields.vue?vue&type=style&index=0&id=9287b008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9287b008",
  null
  
)

export default component.exports